import { cx } from './cx'

/** Shared painted close control. The caller owns what closing means. */
export function CloseButton({ onClose, label = 'Закрыть', className }: { onClose: () => void; label?: string; className?: string }) {
  return <button type="button" className={cx('game-close', className)} onClick={onClose} aria-label={label} title={label}>
    <img src="/assets/ui/close-v01.webp" alt="" aria-hidden="true" draggable={false} />
  </button>
}
